import { render, staticRenderFns } from "./EventsDistribution.vue?vue&type=template&id=0e48b063&"
import script from "./EventsDistribution.vue?vue&type=script&lang=js&"
export * from "./EventsDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventsDistribution.vue"
export default component.exports